import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

export default (props: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="#000"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12" />
    <path d="M1 12C1 12 5 20 12 20C19 20 23 12 23 12" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
